export default "__VITE_ASSET__D$ZRybxS__"